<template>
  <div class="mainCon">
    <div class="stuMainTitle">
      <span class="title">模拟考试</span>
    </div>
    <div class="content">
      <ots-table
        v-if="!showNull"
        :tableHeader="tableHeader"
        :tableData="tableData"
      ></ots-table>
      <div v-else class="noScore">
        <img src="@/assets/stuImg/nothing.png" alt="" />
        <span class="col_grayQ">暂无模考，请等待</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  goOtsStartExam,
  arrangementInfo,
} from "@/http/modules/student/exam";
import { studentMockGetMyMockListApi } from "@/http/modules/applySet/studentMock";

export default {
  name: "stuExamMock",
  data() {
    return {
      showNull: true,
      tableHeader: [
        {
          title: "课程名称",
          prop: "courseName",
          width: "200",
        },
        {
          title: "模考名称",
          prop: "mockName",
          width: "300",
        },
        {
          title: "开始时间",
          prop: "beginTime",
          width: "200",
        },
        {
          title: "结束时间",
          prop: "endTime",
          width: "200",
        },
        {
          title: "已完成次数",
          prop: "mockAnswerTime",
          width: "150",
        },
        {
          title: "操作",
          type: "buttons",
          btnList: [
            {
              formatter: () => "开始模考",
              disableFn: (scope) => this.isMockEnd(scope.row),
              click: this.startMock,
            },
          ],
        },
      ],
      tableData: [],
    };
  },
  created() {
    this.getMockList();
  },
  methods: {
    async getMockList() {
      const { data, code } = await studentMockGetMyMockListApi({
        planId: this.getCurrentGlobalPlanId(),
      });
      if (code === 1 && data) {
        this.tableData = data;
        if (this.tableData.length) {
          this.showNull = false;
        }
      } else {
        this.showNull = false;
      }
    },

    // 开始模考按钮（参考正考 exam.vue 的 startExam 逻辑）
    async startMock(row) {
      if (!(row && row.arrangementId)) {
        return false;
      }
      const ipInfo = await arrangementInfo();
      if (ipInfo.code == 0) {
        return false;
      }
      let param = {
        action: "StartTestNormal",
        parames: `arrangementId=${row.arrangementId}`,
      };
      const { code, data } = await goOtsStartExam(param);
      if (code == 1) {
        window.open(data);
      }
    },

    // 判断该行模考是否已结束（endTime 过了）==> 隐藏【开始模考】按钮
    isMockEnd(row) {
      if (!row || !row.endTime) return false;
      let endTime = row.endTime;
      // 兼容后端 LocalDateTime 序列化为数组 [y,M,d,h,m,s] 的情况
      if (Array.isArray(endTime)) {
        const [y, M, d, h = 0, m = 0, s = 0] = endTime;
        endTime = `${y}/${M}/${d} ${h}:${m}:${s}`;
      } else {
        endTime = String(endTime).replace(/\-/g, "/");
      }
      return new Date().getTime() > new Date(endTime).getTime();
    },
  },
};
</script>
<style lang="less" scoped>
.mainCon {
  box-sizing: border-box;
  padding: 20px;
  padding-top: 16px;
  width: 100%;
  min-width: 700pt;
  background: rgba(255, 255, 255, 0.93);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  .content {
    padding-top: 20px;
    .noScore {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 40px;
      padding-bottom: 80px;
    }
  }
}
/deep/ .el-table th,
.el-table tr {
  background-color: #ebecff !important;
}
.stuMainTitle {
  font-size: 20px;
  height: 52px;
  line-height: 52px;
  font-weight: bold;
  border-bottom: 1px solid #DADDE6;
}
/* 模考已结束的行，隐藏禁用的【开始模考】按钮 */
/deep/ .operate .el-button.is-disabled {
  display: none;
}
</style>
